import type { gameResult } from '@/models/gameUpdate';

export type RecentMatchdayWindow = {
  settledMatchday: number;
  activeMatchday: number;
};

export function getRecentMatchdayWindow(currentMatchday: number): RecentMatchdayWindow {
  return {
    settledMatchday: currentMatchday,
    activeMatchday: currentMatchday + 1,
  };
}

export function isRecentMatchdayResult(result: gameResult, window: RecentMatchdayWindow): boolean {
  if (result.matchday == null) return false;
  return result.matchday === window.settledMatchday || result.matchday === window.activeMatchday;
}
